<div>
	<div class="section-title">Engine Maintenance</div>
	<p>This asset has an available alternate engine configuration. When checked below, any future incoming files
		will have the engine CIs calculated using the alternate configuration.</p>
	<p>Changing this setting does not affect data that has already been imported.</p>
	<div class="mb-3 form-check">
		<label>
			<input [(ngModel)]="asset.alt_engine" (ngModelChange)="UpdateAltEngine()" type="checkbox">
			Enable {{components.alt_engine_name}}
		</label>
	</div>
</div>